import { render, staticRenderFns } from "./PxAutocompleteCategoria.vue?vue&type=template&id=6602a526"
import script from "./PxAutocompleteCategoria.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports